<template>
  <div>
    <div class="content-box">
      <p class="p1">
        <!-- {{ $t("about.title") }} -->
        {{ dataInfo.title }}
      </p>
      <div v-loading="loading" v-html="dataInfo.content"></div>
    </div>
    <VFooter />
  </div>
</template>

<script>
import { mapState } from "vuex";
import VFooter from "@/components/footer/VFooter";
export default {
  name: "download",
  components: {
    VFooter,
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  data() {
    return {
	  loading: false,
      dataInfo: {
        title: '',
        content: ''
      },
    };
  },
  created() {
    this.getDataInfo();
  },
  methods: {
    getDataInfo() {
      const _this = this;
	  this.loading = true;
      this.$axios
        .post("/cms/getList", {
          page: 1,
          rows: 1,
          cateCode: "about-us",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.dataInfo = res.data.data.rows[0] || {};
          }
        }).finally(()=>{
		  this.loading = false;
		});
    },
  },
};
</script>

<style lang="less" scoped>
.content-box {
  position: relative;
  padding: 120px 260px;
  background-color: #f5f6f7;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(~@/assets/img/images/footer-download.png);
  .p1 {
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 36px;
    color: #333333;
    margin-bottom: 60px;
  }
  .p2 {
    /* 首行缩进 2 个字符（核心属性） */
    text-indent: 2em;
    padding: 5px 260px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #1f2329;
  }
}
</style>
